import React from 'react'
import styled from 'styled-components'
import { SideSheet } from './SideSheet'

interface BasicSideSheetProps {
  heading?: string
  isShown: boolean
  onClose?: () => void
  size?: 'sm' | 'md' | 'lg' | 'xl'
  position?: 'left' | 'right'
  children: React.ReactNode
}

export const BasicSideSheet: React.FC<BasicSideSheetProps> = ({
  children,
  isShown,
  heading,
  onClose,
  size = 'md',
  position = 'right'
}) => {
  const handleClose = onClose ?? (() => {})

  return (
    <SideSheet
      heading={heading}
      isShown={isShown}
      handleClose={handleClose}
      size={size}
      position={position}
    >
      <Content>{children}</Content>
    </SideSheet>
  )
}

const Content = styled.div`
  flex: 1;
  display: flex;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.colors.neutralGray};
`
